"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEmptyAppointmentSlots = exports.setParentJumpToDate = exports.clearParentFilters = exports.updateParentFilterBy = exports.clearFilters = exports.setJumpToDate = exports.updateFilterBy = exports.sendParentBack = exports.sendParentNext = exports.selectAppointmentSlots = exports.addAppointmentSlots = exports.setAppointmentSlots = exports.updateQuery = void 0;
const xstate_1 = require("xstate");
const constants_1 = require("../../../lib/constants");
const utils_1 = require("../../../../lib/utils");
const apptTime_utils_1 = require("./apptTime.utils");
const updateQuery = '@actions/UPDATE_APPT_QUERY';
exports.updateQuery = updateQuery;
const setAppointmentSlots = '@actions/SET_APPOINTMENT_SLOTS';
exports.setAppointmentSlots = setAppointmentSlots;
const setEmptyAppointmentSlots = '@actions/SET_EMPTY_APPOINTMENT_SLOTS';
exports.setEmptyAppointmentSlots = setEmptyAppointmentSlots;
const addAppointmentSlots = '@actions/ADD_APPOINTMENT_SLOTS';
exports.addAppointmentSlots = addAppointmentSlots;
const selectAppointmentSlots = '@actions/SELECT_APPOINTMENT_SLOTS';
exports.selectAppointmentSlots = selectAppointmentSlots;
const sendParentNext = '@actions/SEND_PARENT_NEXT';
exports.sendParentNext = sendParentNext;
const sendParentBack = '@actions/SEND_PARENT_BACK';
exports.sendParentBack = sendParentBack;
const updateFilterBy = '@actions/UPDATE_FILTER_BY';
exports.updateFilterBy = updateFilterBy;
const setJumpToDate = '@actions/JUMP_TO_DATE';
exports.setJumpToDate = setJumpToDate;
const setParentJumpToDate = '@actions/PARENT_JUMP_TO_DATE';
exports.setParentJumpToDate = setParentJumpToDate;
const clearFilters = '@action/CLEAR_FILTERS';
exports.clearFilters = clearFilters;
const clearParentFilters = '@action/CLEAR_PARENT_FILTERS';
exports.clearParentFilters = clearParentFilters;
const updateParentFilterBy = '@actions/UPDATE_PARENT_FILTER_BY';
exports.updateParentFilterBy = updateParentFilterBy;
const actions = {
    [updateQuery]: (0, xstate_1.assign)({
        query: (ctx, ev) => {
            return Object.assign(Object.assign(Object.assign({}, ctx.query), ev.data), { periodStart: ev.data.periodStart || ctx.query.periodStart || null });
        },
        // updateQuery is called for every subsequent data load after inital
        isInitialDataLoadFromPreviousStep: false
    }),
    [setAppointmentSlots]: (0, xstate_1.assign)({
        availableSlots: (_ctx, ev) => {
            return ev.data.schedRes;
        },
        lastApptQueriedFor: (_ctx, ev) => ev.data.lastApptQueriedFor
    }),
    [addAppointmentSlots]: (0, xstate_1.assign)((ctx, ev) => {
        var _a, _b;
        // Merge because of how the api time windowing works.
        // We may get an appointment at the head of new list that is the same
        // as the last appointment from the current list
        const mergedAvailableSlots = (0, apptTime_utils_1.mergeAppointments)((_a = ctx.availableSlots) !== null && _a !== void 0 ? _a : [], (_b = ev.data.schedRes) !== null && _b !== void 0 ? _b : []);
        let firstNewAppointmentId;
        if (mergedAvailableSlots.length > ctx.availableSlots.length) {
            firstNewAppointmentId = (0, utils_1.getApptSlotId)(mergedAvailableSlots[ctx.availableSlots.length]);
        }
        return {
            firstNewAppointmentId,
            availableSlots: mergedAvailableSlots,
            lastApptQueriedFor: ev.data.lastApptQueriedFor
        };
    }),
    [selectAppointmentSlots]: (0, xstate_1.assign)({
        selectedSlot: (_ctx, ev) => ev.context.selectedSlot
    }),
    [sendParentNext]: (0, xstate_1.sendParent)((ctx) => {
        const { selectedSlot } = ctx;
        return {
            type: constants_1.events.SELECT_APPOINTMENT,
            context: {
                selectedSlot,
                periodStart: ctx.query.periodStart
            }
        };
    }),
    [sendParentBack]: (0, xstate_1.sendParent)(() => {
        return {
            type: constants_1.events.GO_BACK
        };
    }),
    [updateFilterBy]: (0, xstate_1.assign)({
        filterBy: (ctx, ev) => {
            return Object.assign(Object.assign({}, ctx.filterBy), ev.data);
        }
    }),
    [setJumpToDate]: (0, xstate_1.assign)({
        jumpedToDate: (_ctx, ev) => {
            return ev.data.periodStart;
        }
    }),
    [clearFilters]: (0, xstate_1.assign)({
        filterBy: (_, ev) => {
            return ev.data.filterBy;
        }
    }),
    [updateParentFilterBy]: (0, xstate_1.sendParent)((ctx) => {
        const { filterBy, jumpedToDate } = ctx;
        return {
            type: constants_1.events.UPDATE_FILTER_BY,
            context: {
                filterBy,
                jumpedToDate
            }
        };
    }),
    [clearParentFilters]: (0, xstate_1.sendParent)((_ctx, ev) => {
        return {
            type: constants_1.events.UPDATE_FILTER_BY,
            context: {
                filterBy: ev.data.filterBy
            }
        };
    }),
    [setParentJumpToDate]: (0, xstate_1.sendParent)((_ctx, ev) => {
        return {
            type: constants_1.events.SET_JUMP_TO_DATE,
            context: {
                jumpedToDate: ev.data.periodStart
            }
        };
    }),
    [setEmptyAppointmentSlots]: (0, xstate_1.assign)({
        availableSlots: []
    })
};
exports.default = actions;
//# sourceMappingURL=actions.apptTime.js.map